'use client';
import React from 'react';
import PrivacyTermsWrapper from './PrivacyTermsWrapper';

export default function PrivacyTermsLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return <PrivacyTermsWrapper>{children}</PrivacyTermsWrapper>;
}
